/** Existing directories use both grade and year for the class's grade. */
export function classGrade(cls) {
  const value = [cls?.grade, cls?.year].find(item => item != null && String(item).trim() !== '');
  return value == null ? '' : String(value).trim().replace(/^grade\s+/i, '');
}

export function classGradeLabel(cls) {
  const grade = classGrade(cls);
  return grade ? `Grade ${grade}` : '';
}

/** Display metadata clarifies the choice; persisted class IDs and names stay intact. */
export function classSelectionLabel(cls) {
  if (!cls) return '';
  const name = cls.name || cls.className || cls.displayName || cls.label || '';
  const grade = cls.isGrade ? '' : classGradeLabel(cls);
  return [name, grade].filter(Boolean).join(' · ');
}

/** The same current class/grade choices are available in each recording surface. */
export function searchRecordingClasses(classes = [], query = '', selectedClasses = []) {
  const text = query.trim().toLowerCase();
  if (!text) return [];
  const active = classes.filter(cls => cls?.active !== false);
  const gradeQuery = text.match(/^grade\s+(.+)$/i)?.[1];
  const selectedIds = new Set(selectedClasses.map(cls => cls.id));
  if (gradeQuery) {
    const matches = active.filter(cls => classGrade(cls).toLowerCase() === gradeQuery);
    if (!matches.length) return [];
    const grade = classGrade(matches[0]);
    const choice = { id: `grade-${grade.toLowerCase()}`, name: `Grade ${grade}`, year: grade,
      grade, isGrade: true, classes: matches };
    return selectedIds.has(choice.id) ? [] : [choice];
  }
  return active.filter(cls => !selectedIds.has(cls.id) && classSelectionLabel(cls).toLowerCase().includes(text));
}
